var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-md-flex h-md-100 align-items-center" }, [
      _vm._m(0),
      _c("div", { staticClass: "col-md-5 p-0 bg-white h-md-100 loginarea" }, [
        _c(
          "div",
          { staticClass: "d-md-flex col-12 align-top" },
          [
            _c("img", {
              staticStyle: { "padding-top": "10px" },
              attrs: {
                src: require("@/resources/img/ktb-logo.png"),
                width: "152",
                height: "56"
              }
            }),
            _c("img", {
              attrs: {
                src: require("@/resources/img/h_elg.jpg"),
                width: "284",
                height: "58"
              }
            }),
            _c("router-link", { attrs: { to: "Login" } }, [
              _c("img", {
                attrs: {
                  src: require("@/resources/img/login.jpg"),
                  width: "59",
                  height: "58"
                }
              })
            ])
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "align-items-center h-md-100 p-3 justify-content-center"
          },
          [
            _c(
              "form",
              {
                staticClass: "rounded p-5",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.validateCustomer($event)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "form-group-wrapper" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "have-text",
                          attrs: { for: "custTaxID" }
                        },
                        [_vm._v("Tax ID")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.taxId,
                            expression: "taxId"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|digits:13",
                            expression: "'required|digits:13'"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          input: true,
                          "is-danger": _vm.errors.has("taxId")
                        },
                        attrs: {
                          type: "number",
                          name: "taxId",
                          placeholder: ""
                        },
                        domProps: { value: _vm.taxId },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.taxId = $event.target.value
                          }
                        }
                      }),
                      _c("span", { staticClass: "highlight" }),
                      _c("span", { staticClass: "bar" }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("taxId"),
                              expression: "errors.has('taxId')"
                            }
                          ],
                          staticClass: "help is-danger"
                        },
                        [_vm._v("Tax ID ต้องเป็นตัวเลข 13 หลัก")]
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "have-text",
                            attrs: { for: "custBeneficiary" }
                          },
                          [_vm._v("ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)")]
                        ),
                        _c("v-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true },
                              expression: "{required:true}"
                            }
                          ],
                          staticClass: "vue-select1",
                          class: {
                            input: true,
                            "is-danger": _vm.errors.has("beneficiary")
                          },
                          attrs: {
                            name: "beneficiary",
                            options: _vm.beneficiaryList,
                            label: "nameTH"
                          },
                          on: {
                            input: function($event) {
                              return _vm.getLgTypeList()
                            }
                          },
                          model: {
                            value: _vm.beneficiary,
                            callback: function($$v) {
                              _vm.beneficiary = $$v
                            },
                            expression: "beneficiary"
                          }
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("beneficiary"),
                                expression: "errors.has('beneficiary')"
                              }
                            ],
                            staticClass: "help is-danger"
                          },
                          [_vm._v("ระบุ ผู้รับผลประโยชน์")]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "have-text",
                          attrs: { for: "custLgType" }
                        },
                        [_vm._v("ประเภทค้ำประกัน")]
                      ),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lgTypeObj,
                              expression: "lgTypeObj"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true },
                              expression: "{required:true}"
                            }
                          ],
                          ref: "refLgType",
                          staticClass: "form-control",
                          class: {
                            input: true,
                            "is-danger": _vm.errors.has("lgType")
                          },
                          attrs: { name: "lgTypeObj" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.lgTypeObj = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("เลือกประเภทค้ำประกัน")
                          ]),
                          _vm._l(_vm.custLgTypeList, function(option) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: {
                                    contingentId: option.contingentTypeId,
                                    mtContingentId: option.mtContingentId
                                  }
                                }
                              },
                              [_vm._v(_vm._s(option.contingentTypeNameTh))]
                            )
                          })
                        ],
                        2
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("refLgType"),
                              expression: "errors.has('refLgType')"
                            }
                          ],
                          staticClass: "help is-danger"
                        },
                        [_vm._v("ระบุ ประเภทค้ำประกัน")]
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "have-text",
                            attrs: { for: "custAmount" }
                          },
                          [_vm._v("จำนวนเงินค้ำประกัน(บาท)")]
                        ),
                        _c("vue-numeric", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, min_value: 1 },
                              expression: "{required:true,min_value:1}"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            input: true,
                            "is-danger": _vm.errors.has("amount")
                          },
                          attrs: {
                            separator: ",",
                            precision: 2,
                            name: "amount"
                          },
                          model: {
                            value: _vm.amount,
                            callback: function($$v) {
                              _vm.amount = $$v
                            },
                            expression: "amount"
                          }
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("amount"),
                                expression: "errors.has('amount')"
                              }
                            ],
                            staticClass: "help is-danger"
                          },
                          [_vm._v("จำนวนเงินค้ำประกัน ไม่ถูกต้อง")]
                        )
                      ],
                      1
                    ),
                    _c("recaptcha", {
                      attrs: {
                        sitekey: "6LeSZJoUAAAAAGZFISA4xF41S9Si5sRiPzAZL6Yw",
                        callback: _vm.callbackRecaptchaToken
                      }
                    }),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-info btn-round btn-block shadow-sm",
                        attrs: { type: "submit" }
                      },
                      [_vm._v("ตกลง")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ])
    ]),
    _c("footer", { staticClass: "ft-content space-up" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(1),
          _c("div", { staticClass: "col-6 text-right" }, [
            _c("span", { staticClass: "text-red" }, [
              _vm._v(
                "การทำรายการหลังเวลา 15.00 น. ถือว่าเป็นการทำรายการของวันทำการถัดไป"
              )
            ]),
            _c("br"),
            _c("i", { staticClass: "fa fa-copyright" }),
            _c("span", [
              _vm._v(
                "สงวนสิทธิ์ พ.ศ. 2562 บมจ. ธนาคารกรุงไทย Build Date : " +
                  _vm._s(_vm.buildVersion)
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-7 p-0 bg-indigo h-md-100 logoarea" },
      [
        _c(
          "div",
          {
            staticClass:
              "text-white d-md-flex align-items-center h-100 p-5 text-center justify-content-center"
          },
          [_c("div", { staticClass: "pt-5 pb-5" })]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 text-left" }, [
      _c("i", { staticClass: "feather-icon icon-phone" }),
      _c("span", [_vm._v("02-111-1111, 02-111-9999 KTB Call Center")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }